import { Button, ButtonMode, Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { TableConfiguration } from '../GroupedTableRow/GroupedTableRow.types';
import styles from './GroupedTableColumnHeader.module.scss';

interface GroupedTableColumnHeaderProps<TData, TSort> {
  config: TableConfiguration<TData>;
  onSort: (dataKey: string) => void;
  sortBy?: TSort;
  sortDesc?: boolean;
  noCaret?: boolean;
}

const cx = classNames.bind(styles);

const GroupedTableColumnHeader = <TData extends object, TSort>({
  config,
  onSort,
  sortBy,
  sortDesc,
  noCaret,
}: GroupedTableColumnHeaderProps<TData, TSort>): React.ReactElement => {
  const getSortIcon = (dataKey: string): ICONS => {
    if (sortBy === dataKey) {
      return sortDesc ? ICONS.SortDescending : ICONS.SortAscending;
    }

    return ICONS.ArrowsUpDown;
  };

  return (
    <tr className={cx('body')}>
      <th className={cx('caret-column-heading', { hidden: noCaret })} />
      {config.columns.map((column) => (
        <th
          className={cx('column-th', { alignRight: column.align === 'right' })}
          style={{ width: column.width }}
          key={column.dataKey}
          data-testid={column.header}
        >
          <div className={cx('column-heading')}>
            {config.isSortable ? (
              <Button
                mode={ButtonMode.PLAIN}
                className={cx('column-cell')}
                type="button"
                onClick={() => onSort(column.dataKey)}
              >
                {column.header}
                <div className={cx('sort-btn')}>
                  <Icon name={getSortIcon(column.dataKey)} height={8} width={8} />
                </div>
              </Button>
            ) : (
              column.header
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

export default GroupedTableColumnHeader;
